export default __webpack_public_path__ + "media/images/edit-4b7c021b9cd4d78c15ce690a43ae7138.png";